<template>
  <div class="text-lg mb-4 text-left">รายการสินค้า {{ title }}</div>
  <form @submit.prevent="onFilter" class="flex flex-row sm:mr-auto">
    <div class="sm:flex items-center sm:mr-4">
      <!-- <label class="w-12 flex-none xl:w-auto xl:flex-initial mr-2"
        >คอลัมน์</label
      > -->
      <select
        v-model="filter.field"
        class="form-select w-full sm:w-32 xxl:w-full mt-2 sm:mt-0 sm:w-auto"
      >
        <option
          v-for="opt in filterOption"
          :key="opt.value"
          :value="opt.value"
          >{{ opt.label }}</option
        >
      </select>
    </div>
    <div class="sm:flex items-center sm:mr-4 mt-2 xl:mt-0">
      <label class="w-12 flex-none xl:w-auto xl:flex-initial mr-2">ค้นหา</label>
      <input
        v-model="filter.value"
        type="text"
        class="form-control sm:w-40 xxl:w-full mt-2 sm:mt-0"
        placeholder="Search..."
      />
    </div>
    <div class="mt-2 xl:mt-0">
      <button
        type="button"
        class="btn btn-primary w-full sm:w-16"
        @click="onFilter"
      >
        ค้นหา
      </button>
      <button
        type="button"
        class="btn btn-secondary w-full sm:w-16 mt-2 sm:mt-0 sm:ml-1"
        @click="onResetFilter"
      >
        ยกเลิก
      </button>
    </div>
  </form>
  <div
    id="tabulator"
    ref="tableRef"
    class="mt-5 table-report table-report--tabulator"
  ></div>
</template>

<script>
import Tabulator from 'tabulator-tables'
import {
  defineComponent,
  ref,
  onMounted,
  // onUpdated,
  computed,
  reactive
} from 'vue'
import { myHeaders } from '../../utils/api'
import { useStore } from '@/store'
export default defineComponent({
  name: 'table-material',
  props: {
    modelKey: {
      type: String
    },
    modelValue: {
      type: String,
      default() {
        return null
      }
    },
    materialGroup: {
      type: Object,
      default() {
        return {
          label: null,
          value: null
        }
      }
    },
    orderType: {
      type: String,
      default() {
        return null
      }
    }
  },
  emits: ['setMaterial', 'update:modelValue'],
  setup(props, context) {
    const store = useStore()
    const tableRef = ref()
    const tabulator = ref()

    const title = ref('')

    const filter = reactive({
      field: 'description',
      type: 'like',
      value: ''
    })

    const initTabulator = async () => {
      tabulator.value = new Tabulator(tableRef.value, {
        layout: 'fitDataStretch',
        ajaxURL: process.env.VUE_APP_API_URL + '/preorder/materials/getAll',
        ajaxLoader: true,
        ajaxFiltering: true,
        ajaxSorting: true,
        pagination: 'remote',
        placeholder: 'ไม่พบข้อมูลที่ต้องการ',
        paginationSize: 10,
        paginationSizeSelector: [10, 20, 30, 40],
        ajaxConfig: {
          method: 'GET',
          headers: await myHeaders()
        },
        ajaxResponse: async (url, params, response) => {
          if (response.code == 200) {
            return response.data
          } else {
            await store.commit('notification/toast', {
              type: 'danger',
              message: 'message',
              description: 'desc'
            })
            await store.commit('notification/toastShow', {})
            return false
          }
        },

        ajaxURLGenerator: (url, headers, params) => {
          if (params) {
            const urlNew = []
            if (params.sorters.length > 0) {
              urlNew.push(`sortBy=${params.sorters[0].field}`)
              urlNew.push(`sortDesc=${params.sorters[0].dir == 'desc'}`)
            }
            if (params.page) {
              urlNew.push(`page=${params.page}`)
            }
            if (params.size > 0) {
              urlNew.push(`per_page=${params.size}`)
            }
            if (params.filters.length > 0) {
              urlNew.push(`filterBy=${params.filters[0].field}`)
              urlNew.push(`filter=${params.filters[0].value}`)
            }
            const q = url.indexOf('?') == -1 ? '?' : '&'
            return urlNew.length ? `${url}${q}${urlNew.join('&')}` : url
          } else {
            return url
          }
        },
        columns: [
          {
            title: '',
            field: 'bu_code',
            // width: '100',
            formatter: cell => {
              const a = cash(`<div class="flex lg:justify-center items-center">
                        <a href="javascript:;" data-dismiss="modal" class="btn btn-outline-warning ">
                         เลือก
                        </a>
                    </div>`)
              cash(a).on('click', () => {
                context.emit('update:modelValue', cell.getData().material_code)
                context.emit('setMaterial', cell.getData())
              })
              return a[0]
            }
          },
          {
            title: 'รหัสชนิดสินค้า',
            field: 'description_code'
            // width: '150'
          },
          // {
          //   title: 'รหัสชนิดสินค้า',
          //   field: 'material_type',
          //   width: '130'
          // },
          {
            title: 'รหัสสินค้า',
            field: 'material_code',
            width: '100',
            align: 'center'
          },
          {
            title: 'คงเหลือ',
            field: 'stock_qty',
            width: '100',
            align: 'right',
            formatter: cell => {
              return cell.getData().stock_qty_text
            }
          },
          {
            title: 'รายละเอียดสินค้า',
            field: 'description'
            // width: '700'
          }
          // {
          //   title: 'ราคาต่อหน่วย',
          //   field: 'price',
          //   width: '100'
          // }
          // {
          //   title: 'หน่วย',
          //   field: 'primary_unit',
          //   width: '100'
          // }
        ],
        renderComplete() {
          // console.log('render material')
          // feather.replace({
          //   'stroke-width': 1.5
          // })
        }
      })
    }

    const onFilter = () => {
      tabulator.value.setFilter(filter.field, filter.type, filter.value)
    }

    // On reset filter
    const onResetFilter = () => {
      filter.field = 'description'
      filter.value = ''
      tabulator.value.clearFilter()
    }

    const filterOption = computed(() => store.state.of.materialFilterOption)

    // const setTitle = () => {
    //   const groupTitle = props.materialGroup.find(
    //     item => item.value === props.orderType
    //   )
    //   if (groupTitle) {
    //     title.value = groupTitle.label
    //   }
    // }

    // comment at 2023-08-30 aqua not using
    // watch(
    //   () => props.orderType,
    //   (newVal, oldVal) => {
    //     if (newVal !== null) {
    //       tabulator.value.setData(
    //         process.env.VUE_APP_API_URL +
    //           '/procurement/materials/getAll?material_group=' +
    //           props.orderType
    //       )
    //     }
    //   }
    // )

    onMounted(async () => {
      // console.log('mounted in table material', new Date().getTime(), props)
      await initTabulator()
      // filter.field = store.getters['pr/getFilterDefault']
    })
    // onUpdated(async () => {
    //   // console.log('updated in table material: ', new Date().getTime(), props)
    //   // setTitle()
    // })
    return {
      onResetFilter,
      filterOption,
      tableRef,
      filter,
      onFilter,
      title
    }
  }
})
</script>
